import { render, staticRenderFns } from "./WordCharCounter.vue?vue&type=template&id=c1a04b6c&scoped=true"
import script from "./WordCharCounter.vue?vue&type=script&lang=js"
export * from "./WordCharCounter.vue?vue&type=script&lang=js"
import style0 from "./WordCharCounter.vue?vue&type=style&index=0&id=c1a04b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a04b6c",
  null
  
)

export default component.exports